import { adjust, inPercentage } from "./util"

/** Module de calcul du rendement process */

/** Méthode de calcul du rendement process
 * cf formule document d'explication
 */
export const processYield = (values) => {
    try {
        const processYieldValue = 1 - (values.phosphorusPentoxideG / values.phosphorusPentoxideQQ) * (values.calciumOxideQQ - values.calciumOxideAcid * (values.phosphorusPentoxideQQ / values.phosphorusPentoxideAcid)) / (values.calciumOxideG - values.calciumOxideAcid * (values.phosphorusPentoxideG / values.phosphorusPentoxideAcid))
        const processYieldPercentage = inPercentage(processYieldValue) // le process yield doit être sous forme de pourcentage
        return adjust(processYieldPercentage, 3) // 3 chiffres après la virgule
    } catch (e) {
        throw e
    }
}